import React from 'react';
import { ICheckItem, IListItemProps } from '../../../interfaces/interfaces';
import randomId from '../../../utils/randomId';
import Accordion from '../Accordion/Accordion';
import Checkbox from '../Checkbox/Checkbox';
import List from './List';

function ListItem(props: IListItemProps): JSX.Element {
  const { item, isCheckable, onChange, className } = props;
  const { subItems, topics } = item;
  const domId = randomId('checkbox');
  const childItems = subItems || topics;

  const renderChild = (renderItem: ICheckItem) => {
    const { title, checked, id } = renderItem;
    return (
      <li key={id} className={`item-list-item ${className || ''}`}>
        {(isCheckable && (
          <Checkbox
            id={domId}
            label={title}
            checked={checked}
            onChange={(state: boolean) => {
              if (onChange) {
                onChange(renderItem, state);
              }
            }}
          />
        )) ||
          title}
      </li>
    );
  };

  if (childItems && childItems.length > 1) {
    return (
      <li key={item.id} className="item-list-item has-subitems">
        <Accordion title={item.title} contentCount={childItems.length}>
          <List items={childItems} isChecklist={isCheckable} onItemChange={onChange} />
        </Accordion>
      </li>
    );
  }

  // skip accordion wrap on only one child
  if (childItems && childItems.length === 1) {
    const [firstItem] = childItems;
    return renderChild(firstItem);
  }

  return renderChild(item);
}
export default ListItem;
